import React from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { routes } from 'lane-shared/config';

import { Flex } from 'components';
import { H4, P } from 'components/typography';

import { ClientTask } from 'graphql-query-contracts';

import styles from '../index.scss';

type TaskEquipmentListProps = {
  equipment: ClientTask['equipment'];
  channelSlug: string;
  hasEquipmentAccess: boolean;
  isEquipmentEnabled: boolean;
};

export function TaskEquipmentList({
  equipment,
  channelSlug,
  hasEquipmentAccess,
  isEquipmentEnabled,
}: TaskEquipmentListProps) {
  const { t } = useTranslation();

  if (!equipment || equipment.length === 0) {
    return null;
  }

  return (
    <Flex className={styles.TaskDetailsBlock} width="full" direction="column">
      <H4 mb={3} mt={2}>
        {t(
          'web.admin.workOrder.preventiveMaintenance.task.details.equipment.heading'
        )}
      </H4>
      {equipment.map(
        ({ category, name, id, location, floor, suite }, index) => (
          <Flex
            key={id}
            direction="row"
            className={cx(
              styles.equipmentRow,
              index !== equipment.length - 1 && styles.divider
            )}
          >
            <Flex direction="column" className={styles.equipmentCol}>
              {hasEquipmentAccess && isEquipmentEnabled ? (
                <Link
                  to={routes.channelAdminWorkOrdersEquipmentDetails
                    .replace(':id', channelSlug)
                    .replace(':equipmentId', id)}
                >
                  {name}
                </Link>
              ) : (
                <P>{name}</P>
              )}
              <span className={styles.categorySection}>
                <P className={styles.categoryText}>
                  {t(
                    'web.admin.workOrder.preventiveMaintenance.schedule.details.equipment.category'
                  )}
                </P>
                <P>{category}</P>
              </span>
            </Flex>
            <Flex direction="column" className={styles.equipmentCol}>
              <span>
                <P className={styles.detailsText}>
                  {t(
                    'web.admin.workOrder.preventiveMaintenance.task.details.equipment.location'
                  )}
                </P>
                <P>{location}</P>
              </span>
              {floor ? (
                <span>
                  <P className={styles.detailsText}>
                    {t(
                      'web.admin.workOrder.preventiveMaintenance.task.details.equipment.floor'
                    )}
                  </P>
                  <P>{floor}</P>
                </span>
              ) : null}
              {suite ? (
                <span>
                  <P className={styles.detailsText}>
                    {t(
                      'web.admin.workOrder.preventiveMaintenance.task.details.equipment.suite'
                    )}
                  </P>
                  <P>{suite}</P>
                </span>
              ) : null}
            </Flex>
          </Flex>
        )
      )}
    </Flex>
  );
}
